/**
 * Limites de caractères Immoweb par champ texte multilingue (spec classifieds
 * pipeline v3, `maxLength` du schéma `ClassifiedRequest.texts.*`).
 *
 * Source de vérité partagée entre :
 *  - le formulaire de saisie (`BienDetailPage`) → cap dur côté <input> + compteur ;
 *  - le mapper (`immowebMapper.ts`) → filet de sécurité qui tronque toute valeur
 *    trop longue (données seed/import/API hors formulaire) avant `/upsert`,
 *    sinon Immoweb renvoie 400 `INVALID_TEXTS_HEADLINE_*`.
 *
 * ⚠️ Le miroir Deno `supabase/functions/_shared/immoweb-mapper.ts` tourne dans
 * un runtime séparé et ne peut PAS importer ce fichier : il en duplique les
 * valeurs + la fonction `clampLangText`. Garder les deux synchronisés.
 */
export const IMMOWEB_TEXT_LIMITS = {
  headline: 60,
  description: 2500,
  features: 250,
  extendedInformation: 250,
} as const;

type LangTextLike = { fr?: string; nl?: string; en?: string };

/**
 * Tronque chaque langue d'un texte multilingue à `max` caractères. Filet de
 * sécurité : la saisie est déjà capée côté formulaire, ceci protège les valeurs
 * arrivées par d'autres chemins (seed, import XLSX, API). Coupe nette + trim.
 */
export function clampLangText<T extends LangTextLike | undefined>(lt: T, max: number): T {
  if (!lt) return lt;
  const out: LangTextLike = {};
  (["fr", "nl", "en"] as const).forEach((k) => {
    const v = lt[k];
    if (v == null) return;
    out[k] = v.length <= max ? v : v.slice(0, max).trimEnd();
  });
  return out as T;
}
